/**
 * @generated SignedSource<<606a54b7661adaeda5e4526950c0560e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationSyncHistoryQuery$variables = {
  integrationId: number;
};
export type IntegrationSyncHistoryQuery$data = {
  readonly integration_by_pk: {
    readonly id: number;
    readonly integration_syncs: ReadonlyArray<{
      readonly finished_at: any | null | undefined;
      readonly id: number;
      readonly info_messages: ReadonlyArray<string>;
      readonly started_at: any;
      readonly state: string;
    }>;
  } | null | undefined;
};
export type IntegrationSyncHistoryQuery = {
  response: IntegrationSyncHistoryQuery$data;
  variables: IntegrationSyncHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "integrationId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "integrationId"
      }
    ],
    "concreteType": "integration",
    "kind": "LinkedField",
    "name": "integration_by_pk",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "limit",
            "value": 1
          },
          {
            "kind": "Literal",
            "name": "order_by",
            "value": {
              "id": "desc"
            }
          }
        ],
        "concreteType": "integration_sync",
        "kind": "LinkedField",
        "name": "integration_syncs",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "started_at",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finished_at",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "info_messages",
            "storageKey": null
          }
        ],
        "storageKey": "integration_syncs(limit:1,order_by:{\"id\":\"desc\"})"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationSyncHistoryQuery",
    "selections": (v2/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationSyncHistoryQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c870ca0424170898ab618211c84fc4aa",
    "id": null,
    "metadata": {},
    "name": "IntegrationSyncHistoryQuery",
    "operationKind": "query",
    "text": "query IntegrationSyncHistoryQuery(\n  $integrationId: Int!\n) {\n  integration_by_pk(id: $integrationId) {\n    id\n    integration_syncs(order_by: {id: desc}, limit: 1) {\n      id\n      state\n      started_at\n      finished_at\n      info_messages\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9cd3c6a37563d2c36e488f33406b23e6";

export default node;
